//
// ViewState.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./LayoutState";
import "../../view/Section";
import "./SectionState";

var ViewState = createModule("BIRD::ViewState", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        layoutStates: [1],
        currentSection: 1,
        sectionStates: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ViewState;
